var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["payment-infos-with-slider", _vm.isDesktop ? "desktop" : "mobile"]
    },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.slider1
          ? _c("img", {
              staticClass: "slider",
              attrs: { src: "/imgs/registration/slider1.webp" }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.slider2
          ? _c("img", {
              staticClass: "slider",
              attrs: { src: "/imgs/registration/slider2.webp" }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.slider3
          ? _c("img", {
              staticClass: "slider",
              attrs: { src: "/imgs/registration/slider3.webp" }
            })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2feaff76", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2feaff76","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/slider.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2feaff76","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/slider.vue
// module chunks = 1 2 3